export default __webpack_public_path__ + "static/DSC_0110-3d53f94d1804fb53aede25d518824214.jpg";